import gql from "graphql-tag";

export const uploadsMigrationStatusQuery = () => gql`
	query UploadsMigrationStatus($user_type: EnumUploadUser_type!) {
		uploadsMigrationStatus(user_type: $user_type)
	}
`;
